import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Envelope, Telephone } from 'react-bootstrap-icons';

import BtnIcon from './buttons/btn_icon';

const Contact = ({ variant = 'light' }) => {
	const result = useStaticQuery(graphql`
		query ContactComponent {
			site {
				siteMetadata {
					supportEmail
					supportPhoneNumber
				}
			}

			locales: allLocale {
				...translationFields
			}
		}
	`);
	const site = result.site.siteMetadata;

	const variants = {
		dark: 'dark',
		light: 'light',
	};

	return (
		<>
			<BtnIcon
				className="mb-1"
				label={site.supportPhoneNumber}
				size="sm"
				to={`tel:${site.supportPhoneNumber}`}
				variant={variants[variant]}
			>
				<Telephone />
			</BtnIcon>
			<BtnIcon
				label={site.supportEmail}
				size="sm"
				to={`mailto:${site.supportEmail}`}
				variant={variants[variant]}
			>
				<Envelope />
			</BtnIcon>
		</>
	);
};

Contact.propTypes = {
	variant: PropTypes.string,
};

export default Contact;
